export const MONITORED_FIELDS = [
    'name',
    'isForLegalAge',
    'period',
    'isRead',
    'hasAttachment',
    'title',
    'initialDate',
    'finalDate',
    'startDate',
    'endDate',
    'barcode',
    'storeIds',
    'alertType',
    'productName',
    'recipient',
    'sender',
    'status',
    'barCode',
    'turnOverWithoutSale',
    'categoryId',
    'storeActive',
    'storeOpen',
];
